import React, { Component } from "react";
import explorer_logo from "./../explorer_logo.png";
import react_logo from "./../react_logo.svg";
import redux_logo from "./../redux_logo.svg";
import bootstrap4_logo from "./../bootstrap4_logo.svg";
import adzuna_logo_stacked from "./../adzuna_logo_stacked.svg";
import react_router from "./../react_router.svg";

import home_splash from "./../home_splash.png";
import {
  Navbar,
  Progress,
  Nav,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";

class Home extends Component {
  render() {
    if (this.props.noSearchDone) {
      return (
        <div className="home-Welcome">
          <Row>
            <Col sm="12" />
          </Row>
          <Row>
            <Col sm="1" />
            <Col sm="5">
              <h2>Search & Explore UK Jobs.</h2>
              <div className="main-Copy">
                <h5>Use the form fields above to start your search.</h5>
                <p>
                  This App allows you to load all the results for a given role
                  and location onto a single page. From there you can easily
                  filter and search within your results to find suitable roles
                  and save them to your favourites.
                </p>
                <h5>Go on and give it a try! </h5>
                <p>
                  For example: search for "Javascript" in "London" for last 7
                  days.{" "}
                </p>
              </div>
              <h4> Built using the following technologies:</h4>
              <Row className="logosRow">
                <Col>
                  <img src={react_logo} className="home-logos" alt="logo" />
                </Col>
                {/*
                <Col>
                  <img src={redux_logo} className="home-logos" alt="logo" />
                </Col>
                
                <Col>
                  <img src={react_router} className="home-logos" alt="logo" />
                </Col>
                */}
                <Col>
                  <img
                    src={bootstrap4_logo}
                    className="home-logos"
                    alt="logo"
                  />
                </Col>
                <Col>
                  <img
                    src={adzuna_logo_stacked}
                    className="home-logos"
                    alt="logo"
                  />
                </Col>
              </Row>
              <p className="data-Row">
                ** The Data for this App is provided by the{" "}
                <a href="https://developer.adzuna.com/overview">
                  Adzuna Jobs API
                </a>
              </p>
            </Col>
            <Col xs="5" className="d-none d-md-block" />
            <Col xs="1" className="d-none d-md-block" />
          </Row>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Home;
